import { CartOrder } from './../models/cart-order';
import { CartItem } from './../models/cart-item';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { actionUrl, handleError, getHeaders } from '../util/common';
import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HistoryItem } from '../models/history';
import { Receipt } from '../models/receipt';
import { getDate } from '../util/tools';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(private http: HttpClient) { }


  public addCartItem(cartItem: CartItem): Observable<any> {
    const url = `${actionUrl}/AddCartItem`;
    return this.http.post<CartItem>(url, cartItem, getHeaders(true)).pipe(
      map(CartItemGUID => {
        return CartItemGUID;
      }),
      catchError(handleError<any>(` not found`))
    );
  }

  public addCartOrderSync(cartOrder: CartOrder): Observable<any> {
    const url = `${actionUrl}/addCartOrderSync`;
    return this.http.post<CartItem>(url, cartOrder, getHeaders(true)).pipe(
      map(response => {
        return response;
      }),
      catchError(handleError<any>(` not found`))
    );
  }

  public getOrdersWithItemsByDeviceUUID(): any {

    const url = `${actionUrl}/GetOrdersWithItemsByDeviceUUID`;
    return this.http.post<HistoryItem>(url,
      { "StartDate": getDate(7), "EndDate": getDate(null) }
      , getHeaders(true)).pipe(
        map(հistoryItem => {
          return հistoryItem;
        }),
        catchError(handleError<any>(` not found`))
      );
  }

  public getItemReceipt(id: string): any {
    const url = `${actionUrl}/GetItemReceipt?Guid=${id}`;
    return this.http.get<Receipt[]>(url, getHeaders(true)).pipe(
      map(receipt => {
        return receipt;
      }),
      catchError(handleError<any>(` not found`))
    );
  }


  public getProviderTree(id: string): Observable<any> {
    const url = `${actionUrl}/GetProviderTree?Guid=${id}`;
    return this.http.get<Receipt[]>(url, getHeaders(true)).pipe(
      map(tree => {
        return tree;
      }),
      catchError(handleError<any>(` not found`))
    );
  }

  public ProviderDetails(id: string): Observable<any> {
    
    const url = `${actionUrl}/GetProviderDetails?Guid=${id}`;
    return this.http.get<Receipt[]>(url, getHeaders(true)).pipe(
      map(details => {
        return details;
      }),
      catchError(handleError<any>(` not found`))
    );
  }

  public sendReceiptToEmail(id: string, email: string): Observable<any> {
    const url = `${actionUrl}/SendReceiptEmail`;
    return this.http.post<any[]>(url, {
      "ItemGuid": id,
      "Email": email,
      "Lang": "hy"
    }, getHeaders(true)).pipe(
      map(sendedMailResponse => {
        return sendedMailResponse;
      }),
      catchError(handleError<any>(` not found`))
    );
  }
}
